<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{ on }">
        <v-icon :color="item.hasBCA ? 'success' : 'secondary'" v-on="on">
          mdi-access-point-network
        </v-icon>
      </template>
      <span>BCA</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template #activator="{ on }">
        <v-icon :color="item.hasPvC ? 'success' : 'secondary'" v-on="on">
          mdi-cloud-lock
        </v-icon>
      </template>
      <span>PvC</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template #activator="{ on }">
        <v-icon :color="item.hasDL ? 'success' : 'secondary'" v-on="on">
          mdi-face-agent
        </v-icon>
      </template>
      <span>DL</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template #activator="{ on }">
        <v-icon :color="item.hasVDSL ? 'success' : 'secondary'" v-on="on">
          mdi-ip-outline
        </v-icon>
      </template>
      <span>VDSL</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template #activator="{ on }">
        <v-icon
          :color="item.hasDirectConnect ? 'success' : 'secondary'"
          v-on="on"
        >
          mdi-lan-connect
        </v-icon>
      </template>
      <span>DirectConnect</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template #activator="{ on }">
        <v-icon :color="item.hasLTE ? 'success' : 'secondary'" v-on="on">
          mdi-wifi
        </v-icon>
      </template>
      <span>LTE</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
   props: {
      item: {
         type: Object,
         required: true,
      },
   },
}
</script>

<style>
</style>
